import { xyIntegration } from 'ml-spectra-processing';
import { mapRanges } from 'nmr-processing';
import detectSignals from './detectSignals';
export function resizeRange(spectrum, options) {
    const { range, from, to, logger } = options;
    const { x, re: y } = spectrum.data;
    const { originFrequency: frequency, nucleus } = spectrum.info;
    const absolute = xyIntegration({ x, y }, { from, to });
    const signals = detectSignals({ x, y }, {
        from,
        to,
        nucleus,
        frequency,
        logger,
    });
    const [newRange] = mapRanges([
        {
            ...range,
            originalFrom: from,
            originalTo: to,
            from,
            to,
            absolute,
            signals,
        },
    ], spectrum);
    return newRange;
}
